// extracted by mini-css-extract-plugin
export default {"logo":"LogoApp_logo__xzvx5","whiteLabeled":"LogoApp_whiteLabeled__wby66","small":"LogoApp_small__b1KUE"};